import FilterButtonStyles from 'directory/base/FilterButtonStyles';
import FilterLink from 'directory/base/FilterLink';
import React, { FC } from 'react';

interface TProps {
  filterKeys?: any;
  baseLink?: any;
}

const FilterButton: FC<TProps> = ({ filterKeys, baseLink }) => {
  return (
    <>
      <FilterButtonStyles>
        <h2>Browse by</h2>
        <div className="browser-wrap">
          <FilterLink exists={true} to={baseLink} filterName={'All'} />
          <FilterLink
            exists={filterKeys.includes('#')}
            to={`${baseLink}/hash`}
            filterName={'#'}
          />
          {new Array(26).fill(1).map((_, i) => {
            const alphabet = String.fromCharCode(97 + i);
            const isContain = filterKeys.includes(alphabet);
            return (
              <FilterLink
                key={alphabet}
                exists={isContain}
                to={`${baseLink}/${alphabet}`}
                filterName={alphabet}
              />
            );
          })}
          <FilterLink
            exists={filterKeys.includes('other')}
            to={`${baseLink}/more`}
            filterName={'Other'}
          />
        </div>
      </FilterButtonStyles>
    </>
  );
};
export default FilterButton;
